import CommentItem from './CommentItem';

const DossierSidebarComments = ({ user, items, updatingCommentId, commentEditForm, onCommentAction }) => {
  const getCommentProps = (c, firstPinned) => ({
    key: c.id,
    ...c,
    firstPinned,
    updatingCommentId,
    commentEditForm,
    onCommentAction,
    currentUser: user
  });

  return (
    <>
      {items
        ?.filter((c) => !c.pinned)
        ?.map((c) => (
          <CommentItem {...getCommentProps(c)} />
        ))}
      {items
        ?.filter((c) => !!c.pinned)
        ?.map((c, i) => (
          <CommentItem {...getCommentProps(c, i === 0)} />
        ))}
    </>
  );
};

export default DossierSidebarComments;
